import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * ProtectedRoute - Checks if user has required permission before rendering component
 * If permission check fails, redirects to specified fallback (default: /select-module)
 */
function ProtectedRoute({ 
  user, 
  requiredPermission, 
  children, 
  fallbackPath = "/select-module" 
}) {
  const [checking, setChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    checkPermission();
  }, [user, requiredPermission]);

  const checkPermission = async () => {
    if (!user) {
      setHasAccess(false);
      setChecking(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API}/auth/me/permissions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const permissions = response.data.effective_permissions || [];
      const need = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
      setHasAccess(need.some((p) => permissions.includes(p)));
    } catch (error) {
      console.error("Permission check failed:", error);
      setHasAccess(false);
    } finally {
      setChecking(false);
    }
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
}

export default ProtectedRoute;
